import { LargeText, ScreenRoot } from "../styles";
import React, { useEffect, useState } from "react";
import { SearchBar } from "../../contractorDashboard/detailScreens/SearchBar";
import { useDispatch, useSelector } from "react-redux";
import {
  esubSelectedInfoSelector,
  esubSelector,
} from "../../../data/selectors/user";
import {
  getEsubInfo,
  getEsubs,
} from "../../../data/actions/user";
import { getSelectedEsubInfo } from "../../../api/external_data";
import { BackButton } from "../../../components/backButton";
import { useHistory } from "react-router";
import { ESUBData, ESubInfo } from "../../newPreQualify/components/bondDetails/types";
import { ESUBTable } from "./Table";
import { contactSelector } from "data/selectors/contact";
import { getContact } from "data/actions/contact";
import { getInstitutionInvitedESUBs } from "data/actions/underwriters";
import { institutionInvitedEsubsSelector } from "data/selectors/underwriters";
import { ESUBList } from "pages/contractorDashboard/detailScreens/ESUBList";
import { deleteSingleEsub } from "api/esub";

export const ViewESUB = () => {

  const dispatch = useDispatch();
  const history = useHistory();
  const esubs = useSelector(esubSelector);
  const esubsInfo = useSelector(esubSelectedInfoSelector);

  const [eSUBs, setESUBs] = useState<ESubInfo[]>(esubs);
  const [eSUBsInfo, setESUBsInfo] = useState<any[]>(esubs);

  // Search state variables
  const [query, setQuery] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [internalSearchResults, setInternalSearchResults] = useState([]);
  const [isLoading, setIsLoading] = useState(true); // Start with loading true

  // Safe wrapper for setInternalSearchResults to ensure it's always an array
  const setInternalSearchResultsSafe = (results) => {
    setInternalSearchResults(Array.isArray(results) ? results : []);
  };

  const contact = useSelector(contactSelector);

  const invitedESubList = useSelector(institutionInvitedEsubsSelector);
  const esubList = useSelector(esubSelector);

  // Debug logging
  console.log('ViewESUB - isLoading:', isLoading);
  console.log('ViewESUB - esubList:', esubList);
  console.log('ViewESUB - invitedESubList:', invitedESubList);

  const user = JSON.parse(localStorage.getItem("User"));
  const isAgentUnderwriter = user.is_agent_to_access_esub_and_idp;

  useEffect(() => {
    if (!contact) {
      dispatch(getContact());
    }
  }, [dispatch, contact]);


  useEffect(() => {
    if (isAgentUnderwriter) {
      if ((!esubList || (Array.isArray(esubList) && esubList.length === 0) || (typeof esubList === 'object' && Object.keys(esubList).length === 0)) && 
          contact && contact.user_access_control && contact.user_access_control.institution_id) {
        console.log('Setting loading to true for getEsubs');
        setIsLoading(true);
        dispatch(getEsubs(
          { institution_id: contact.user_access_control.institution_id },
          () => {
            console.log('getEsubs onSuccess - setting loading to false');
            setIsLoading(false);
          }, // onSuccess
          () => {
            console.log('getEsubs onFailed - setting loading to false');
            setIsLoading(false);
          }  // onFailed
        ));
      }
          } else {
        if (invitedESubList.length === 0) {
          console.log('Setting loading to true for getInstitutionInvitedESUBs');
          setIsLoading(true);
          dispatch(getInstitutionInvitedESUBs(
            undefined,
            () => {
              console.log('getInstitutionInvitedESUBs onSuccess - setting loading to false');
              setIsLoading(false);
            }, // onSuccess
            () => {
              console.log('getInstitutionInvitedESUBs onFailed - setting loading to false');
              setIsLoading(false);
            }  // onFailed
          ));
        }
      }
  }, [contact, isAgentUnderwriter, invitedESubList.length, esubList.length, dispatch]);

    useEffect(() => {
    if (isAgentUnderwriter) {
      setESUBs(esubList);
      setFilteredData(Array.isArray(esubList) ? esubList : []);
      // Set loading to false if we have data or if the data fetch is complete
      if (esubList && (Array.isArray(esubList) || Object.keys(esubList).length > 0)) {
        console.log('Setting loading to false - esubList has data');
        setIsLoading(false);
      }
    } else {
    if (invitedESubList) {
        setESUBs(invitedESubList);
        setFilteredData(Array.isArray(invitedESubList) ? invitedESubList : []);
        // Set loading to false if we have data
        if (invitedESubList.length > 0) {
          console.log('Setting loading to false - invitedESubList has data');
          setIsLoading(false);
        }
      }
    }
  }, [invitedESubList, esubList]);

  const editESUB = (id) => {
    history.push("/prequalify/qualifying?e-sub=true", {
      action: "edit-esub",
      esubId: id,
      institution_id:  "",
    });
  };

  const deleteESUB = (id) => {
    deleteSingleEsub(id, onSuccessDelete, () => { console.error("Error deleting esub"); });
  };

  const onSuccessDelete = (res) => {
    dispatch(getEsubs({ institution_id: contact?.user_access_control?.institution_id ?? "" }));
    setQuery("");
  };

  const handleGoBack = () => {
    history.push("/underwriter-dashboard");
  };

  return (
    <ScreenRoot>
      <div style={{ display: "flex", flexDirection: "column" }}>
        <BackButton
          handleClick={handleGoBack}
          margin={"20px 0 0 0"}
          buttonText={undefined}
        />
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            margin: "24px 0 16px 0",
          }}
        >
          <LargeText>All eSUBs</LargeText>
          <SearchBar
            filterApi={undefined}
            setFilteredData={undefined}
            searchWidth="30%"
            filteredData={filteredData}
            setInternalSearchResults={setInternalSearchResultsSafe}
            query={query}
            setQuery={setQuery}
            internalSearch={true}
            searchPlaceHolder={undefined}
            marginRight="0px"
          />
        </div>
        {isAgentUnderwriter
          ? (
            <ESUBList
              filteredData={
                query && query !== "" ? (internalSearchResults || []) : (filteredData || [])
              }
              editFunc={editESUB}
              deleteFunc={deleteESUB}
              isMobile={false}
              isContractorView={false}
              isLoading={isLoading}
            />
          )
          : <ESUBTable isLoading={isLoading} eSUBs={eSUBs} institutionId={contact?.user_access_control?.institution_id ?? 0} />
        }

      </div>
    </ScreenRoot>
  );
};
